import type { SeasonPackage } from './types';
import type { Theme } from './theme';

const pending = new Map<string, Promise<void>>();
/** Only the requested mode is fetched; failed requests remain retryable. */
export async function preloadLandscape(pkg: SeasonPackage, mode: Theme): Promise<void> {
  if (typeof Image === 'undefined') return;
  await Promise.all(
    pkg.landscape.layers
      .filter((layer) => !layer.theme || layer.theme === (mode === 'dark' ? 'night' : 'day'))
      .flatMap((layer) => layer.raster?.[mode] ?? [])
      .map(async (part) => {
        // Match the picture's art-directed source before preloading, including
        // inline placeholders for scenery hidden at this viewport size.
        const src = part.sources?.find(source =>
          typeof window !== 'undefined' && window.matchMedia(source.media).matches,
        )?.srcSet ?? part.src;
        let request = pending.get(src);
        if (!request) {
          const image = new Image();
          image.decoding = 'async';
          image.src = src;
          request = image.decode().catch((error: unknown) => {
            pending.delete(src);
            throw error;
          });
          pending.set(src, request);
        }
        await request;
      }),
  );
}
